import { Outlet } from 'react-router';

import App from './App';

/**
 * The app, and whatever is drawn over it.
 *
 * `/` and `/account/*` share this one layout route, so the account page opens
 * *over* the app rather than in place of it. Before, `/account` was a sibling
 * of `/`: App unmounted, and with it went the view, the filters, the sidebars
 * and every scroll position, so coming back always landed on Explore at the top
 * of the list. Keeping App mounted is also what lets the view toggle stay
 * exactly where it is while the account page is open, which is the point of it
 * being one control for three places rather than two controls and a link.
 *
 * `/account/welcome` and `/s/:token` stay outside: both are whole pages in
 * their own right, and neither has a view to come back to.
 */
export default function AppShell() {
  /**
   * The account page is App's child rather than its sibling so that App can
   * hand it the week's totals and "Clear my Schedule" (`WeekContext`). It is
   * still drawn over App, by its own fixed positioning, exactly as before.
   */
  return (
    <App>
      <Outlet />
    </App>
  );
}
